import DefaultContainer from '../default_container';

const ComingSoon = () => {
  return (
    <DefaultContainer isWelcomeMessage={true}>
      <div
        style={{
          /* margin-top: 50px; */
          fontWeight: 900,
          fontSize: '40px',
          color: 'white',
          textAlign: 'center',
          display: 'flex',
          /* align-items: initial; */
          justifyContent: 'center',
          marginTop: '250px'
        }}>
        Coming soon
      </div>
    </DefaultContainer>
  );
};

export default ComingSoon;
